import React from "react";
import PropTypes from "prop-types";

import MDBox from "shared/components/MDBox";
import MDTypography from "shared/components/MDTypography";
import TableCameContent from "./TableCameContent";

function TableCame({ refreshFlag, onError, currentUserRole, isAdmin }) {
  // Si no es administrador, mostrar mensaje o no mostrar nada
  if (!isAdmin) {
    return (
      <MDBox>
        <MDBox mb={3} textAlign="center">
          <MDTypography variant="h6" color="info" gutterBottom>
            🔒 Vista restringida
          </MDTypography>
          <MDTypography variant="body2" color="text.secondary" mb={2}>
            El historial está disponible para Admin, Planeación y los administradores ISERRA
            autorizados
          </MDTypography>
          <MDTypography variant="body2" color="text.secondary" mb={1}>
            Roles autorizados:
          </MDTypography>
          <MDBox component="ul" sx={{ textAlign: "left", display: "inline-block", mb: 2 }}>
            <li>
              <MDTypography variant="caption" color="text.secondary">
                Admin
              </MDTypography>
            </li>
            <li>
              <MDTypography variant="caption" color="text.secondary">
                Planeación
              </MDTypography>
            </li>
            <li>
              <MDTypography variant="caption" color="text.secondary">
                Admin iserra100
              </MDTypography>
            </li>
            <li>
              <MDTypography variant="caption" color="text.secondary">
                Admin iserra100 Gerencia
              </MDTypography>
            </li>
            <li>
              <MDTypography variant="caption" color="text.secondary">
                Admin iserra100 Supervisor
              </MDTypography>
            </li>
          </MDBox>
          {currentUserRole && (
            <MDBox mt={2}>
              <MDTypography variant="caption" color="text.secondary">
                Tu rol actual: <strong>{currentUserRole}</strong>
              </MDTypography>
            </MDBox>
          )}
        </MDBox>
      </MDBox>
    );
  }

  // Si es administrador, mostrar la tabla completa
  return <TableCameContent refreshFlag={refreshFlag} onError={onError} />;
}

TableCame.propTypes = {
  refreshFlag: PropTypes.bool,
  onError: PropTypes.func,
  currentUserRole: PropTypes.string,
  isAdmin: PropTypes.bool,
};

TableCame.defaultProps = {
  refreshFlag: false,
  onError: null,
  currentUserRole: "",
  isAdmin: false,
};

export default TableCame;
